import { Api } from 'Common/utils';

export function fetchUser() {
    return Api.GET('/user');
}
